import type { IResponseEventMessage } from 'entities/Message'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useEventMessageUpdatedNewGlobal } from 'entities/Conversation/events/EventMessageUpdatedNewGlobal'
import type { ContactsConversationOpenStore } from 'widgets/ContactsDetails/ui/ContactsConversationOpen'

export const useEventMessageUpdatedNew = (
  contactsConversationOpenStore: ContactsConversationOpenStore
) => {
  const { conversationStore } = useEntitiesContext()
  const handler = (data: IResponseEventMessage) => {
    const conversation = conversationStore.addItem(data.conversation)
    const conversationMessageStore = contactsConversationOpenStore.conversationMessagesStore

    if (data.message.conversation_id === conversationMessageStore.conversationId) {
      if (contactsConversationOpenStore.inbox?.id !== data.conversation.inbox_id) return
      if (conversationMessageStore.conversationId) return

      contactsConversationOpenStore.contactsDetailsStore.setConversationId(conversation.id)
      conversationMessageStore.setItems([data.message])
    }
  }

  useEventMessageUpdatedNewGlobal(handler)
}
